/* global DetectUserAgent */
import { isNil } from "ramda";
import { parse } from "qs";

import useRouter from "./useRouter";

const useUtmsParams = () => {
  const { location } = useRouter();
  let utmsParams = null;

  if (DetectUserAgent.isAndroid()) {
    const params = location.search
      ? parse(location.search, { ignoreQueryPrefix: true })
      : parse(location.hash.slice(1));
    if (!isNil(params.state)) {
      utmsParams = params.state;
    }
  }

  return { utmsParams };
};

export default useUtmsParams;
